module.exports = __webpack_public_path__ + "img/gi.a9a67e79.png";